


























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Comment from '../../../api/v2/models/comment'
import User from '../../models/user'
import Simplemde from './Simplemde.vue'

@Component({
  components: {
    Simplemde
  }
})
export default class CommentComponent extends Vue {
  @Prop({ required: true })
  comment: Comment

  @Prop({ default: null })
  user: User | null

  @Prop()
  deleteComment: (id: number) => Promise<void> | undefined

  @Prop()
  updateComment: (comment: Comment) => Promise<void> | undefined
}
